// extracted by mini-css-extract-plugin
module.exports = {"product-card":"shopping_product-card__4MI9r","shopping__action":"shopping_shopping__action__01eVO","counter":"shopping_counter__TNqu_"};